module.exports = __webpack_public_path__ + "7bc9b7d147a78aec6788ec765f9eed7e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/toast-s.png
// module id = 2626
// module chunks = 0